import React from "react";
import { Header, Footer } from "./PublicLayout";
import MobileBottomNav from "../components/MobileBottomNav";

/* ============================================================================
   LEGAL PAGE LAYOUT
   Uses the canonical Header + Footer for full site consistency, with a
   narrow reading column for legal/informational content.
   ============================================================================ */

const LegalLayout = ({ children }) => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'white' }}>
      <Header />
      <main
        id="main-content"
        style={{
          flex: 1,
          padding: '48px 24px',
          maxWidth: '800px',
          margin: '0 auto',
          width: '100%',
        }}
      >
        {children}
      </main>
      <Footer />
      <MobileBottomNav />
      <div className="mobile-nav-clearance" aria-hidden="true" />
      <style>{`
        .mobile-nav-clearance { display: none; }
        @media (max-width: 900px) {
          .mobile-nav-clearance { display: block; height: calc(60px + env(safe-area-inset-bottom, 0px)); }
        }
      `}</style>
    </div>
  );
};

export default LegalLayout;
